import { Box, Paper, Typography } from '@mui/material'
import { Loader } from 'Common/Loader/Loader'

export const WorkcentreRunInitiatedView = () => {
  return (
    <>
      <Paper
        sx={{
          padding: '20px',
          textAlign: 'center',
          margin: '20px',
        }}
      >
        <Box>
          <Loader />
        </Box>
        <Box mb={2} display="flex" justifyContent="center">
          <Typography variant="h2">
            Constrained plan is being run for this workcentre.
          </Typography>
        </Box>
        <Box mb={4} display="flex" justifyContent="center">
          <Typography variant="h4">
            This may take a while. You can return to this screen after a few
            minutes.
          </Typography>
        </Box>
      </Paper>
    </>
  )
}
